import ajax from "./ajax";

export function getUnreadNotifications() {
  return ajax("/notifications/unread");
}

export function markNotificationRead(id) {
  return ajax(`/notifications/${id}/read`, { method: "POST" });
}
